import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
    LearningPortfolioAttachment,
    LearningPortfolioCategory,
    LearningPortfolioNote,
    LearningPortfolioNoteUpdate,
    LearningPortfolioNoteValue,
    LearningPortfolioParams,
    LearningPortfolioNoteList,
} from '../models';

export const learningPortfolioActions = createActionGroup({
    source: 'LearningPortfolio',
    events: {
        'Get Notes': props<{ params: LearningPortfolioParams }>(),
        'Get Notes Success': props<{ params: LearningPortfolioParams; payload: LearningPortfolioNoteList }>(),
        'Get Notes Error': props<{ params: LearningPortfolioParams }>(),

        'Get Note': props<{ id: string }>(),
        'Get Note Success': props<{ payload: LearningPortfolioNote }>(),
        'Get Note Error': props<{ id: string }>(),

        'Get Categories': emptyProps(),
        'Get Categories Success': props<{ payload: LearningPortfolioCategory[] }>(),
        'Get Categories Error': emptyProps(),

        'Create Category': props<{ name: string }>(),
        'Create Category Success': props<{ payload: LearningPortfolioCategory }>(),
        'Create Category Error': emptyProps(),

        'Create Note': props<{ value: LearningPortfolioNoteValue }>(),
        'Create Note Success': props<{ payload: LearningPortfolioNote }>(),
        'Create Note Error': emptyProps(),

        'Update Note': props<{ id: string; value: LearningPortfolioNoteUpdate }>(),
        'Update Note Success': props<{ payload: LearningPortfolioNote }>(),
        'Update Note Error': emptyProps(),

        'Clear Saved': emptyProps(),

        'Upload Attachments': props<{ uploadId: string; files: File[] }>(),
        'Upload Attachments Success': props<{ uploadId: string; payload: LearningPortfolioAttachment[] }>(),
        'Upload Attachments Error': props<{ uploadId: string }>(),

        'Remove Attachment': props<{ id: string }>(),
        'Set Attachments': props<{ payload: LearningPortfolioAttachment[] }>(),
        'Clear Attachments': emptyProps(),

        'Delete Note': props<{ id: string }>(),
        'Delete Note Success': props<{ id: string }>(),
        'Delete Note Error': emptyProps(),

        'Clear Deleted': emptyProps(),

        Clear: emptyProps(),
    },
});
